import { render } from "./AppHeaderMenuCustomer.vue?vue&type=template&id=397b8547&scoped=true"
import script from "./AppHeaderMenuCustomer.vue?vue&type=script&lang=js"
export * from "./AppHeaderMenuCustomer.vue?vue&type=script&lang=js"

import "./AppHeaderMenuCustomer.vue?vue&type=style&index=0&id=397b8547&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397b8547"]])

export default __exports__